import { uniqId } from '@utils/id';
export default class MenuWidget {
    constructor(element) {
        if (!element)
            throw new Error('undefined element');
        this.element = element;
        this.init();
    }
    init() {
        this.element.querySelectorAll('.menu__submenu').forEach((submenu) => {
            const submenuId = submenu.getAttribute('id') || uniqId('submenu');
            submenu.setAttribute('id', submenuId);
            const item = submenu.closest('.menu__item');
            if (item) {
                item === null || item === void 0 ? void 0 : item.classList.add('menu__item--submenu');
                const toggle = document.createElement('button');
                toggle.type = 'button';
                toggle.classList.add('menu__item-toggle');
                toggle.setAttribute('aria-expanded', 'false');
                toggle.setAttribute('aria-controls', submenuId);
                toggle.addEventListener('click', this.handleToggleClick.bind(this));
                item.append(toggle);
            }
        });
    }
    handleToggleClick(event) {
        const target = event.target;
        const item = target === null || target === void 0 ? void 0 : target.closest('.menu__item--submenu');
        if (item) {
            const isOpen = item.classList.contains('is-open');
            this.toggleItem(item, !isOpen);
        }
    }
    toggleItem(item, open = true) {
        if (item && item.classList.contains('menu__item--submenu')) {
            const toggle = item.closest('.munu__item-toggle');
            item.classList.toggle('is-open', open);
            toggle === null || toggle === void 0 ? void 0 : toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
        }
    }
    closeAll() {
        this.element.querySelectorAll('.menu__item--submenu').forEach((item) => {
            this.toggleItem(item, false);
        });
    }
}
document.querySelectorAll('.menu').forEach((element) => {
    element.MenuWidget = new MenuWidget(element);
});
